<template>
  <el-table-column
    prop="barcode"
    label="#"
    width="70"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      {{ scope.row.product_id }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'barcode',
  };
</script>
